// extracted by mini-css-extract-plugin
export default {"InterviewInfo":"styles_InterviewInfo__b5H0U","orange":"styles_orange__BbvC2","green":"styles_green__GKKbW","red":"styles_red__Y9pKA"};